module.exports = __webpack_public_path__ + "static/media/09d.4e35cc56.png";